export const HEADER = {
  logo: {
    src: null,
    alt: "Mosabbir A.",
  },
  menus: [
    {
      name: "Home",
      to: "Hero",
    },
    {
      name: "About",
      to: "About",
    },
    {
      name: "Resume",
      to: "Resume",
    },
    {
      name: "Works",
      to: "Portfolio",
    },
    {
      name: "Gallery",
      to: "Blogs",
    },
    {
      name: "Contact",
      to: "Contact",
    },
  ],
};
